import { Component, inject } from '@angular/core';
import { MatProgressBar } from '@angular/material/progress-bar';
import { Store } from '@ngrx/store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { intervalToDuration } from 'date-fns';
import { selectSelectedForecastVersion } from 'demand-forecasting/store/forecast-version/forecast-version.selectors';
import { LucideGauge } from '@lucide/angular';
import { PmIconComponent } from '@libs/ui';

@Component({
  selector: 'pm-version-is-calculating',
  templateUrl: './version-is-calculating.component.html',
  imports: [MatProgressBar, TranslateModule, PmIconComponent, PmIconComponent],
  host: {
    class: 'block',
  },
})
export class VersionIsCalculatingComponent {
  private readonly store = inject(Store);
  private readonly translate = inject(TranslateService);

  protected readonly GaugeIcon = LucideGauge;

  forecastVersion = this.store.selectSignal(selectSelectedForecastVersion);

  protected timeText(time: number): string {
    const res = intervalToDuration({ start: 0, end: time * 1000 });
    const hourString = res.hours
      ? `${res.hours} ${
          res.hours > 1
            ? this.translate.instant('UTILITY.HOURS')
            : this.translate.instant('UTILITY.HOUR')
        }`
      : '';
    const minuteString = res.minutes
      ? `${res.minutes} ${
          res.minutes > 1
            ? this.translate.instant('UTILITY.MINUTES')
            : this.translate.instant('UTILITY.MINUTE')
        }`
      : '';
    const secondString = res.seconds
      ? `${res.seconds} ${
          res.seconds > 1
            ? this.translate.instant('UTILITY.SECONDS')
            : this.translate.instant('UTILITY.SECOND')
        }`
      : '';

    // we only want to display maximum 2 time units
    // if hours exists, we only want to display hours and minutes
    // if minutes exists, we only want to display minutes and seconds
    // if seconds exists, we only want to display seconds
    if (hourString) {
      return `${hourString} ${minuteString}`;
    }
    if (minuteString) {
      return `${minuteString} ${secondString}`;
    }
    return `${secondString}`;
  }
}
